import { ReactNode } from "react";
import { Button } from "antd";
import "./scroll-to-top-button.scss";
import { ToTopIcon } from "@/shared/assets/svg/icons";

interface IScrollToTopButton {
  children: ReactNode;
}

export const ScrollToTopButton = ({ children }: IScrollToTopButton) => {
  const moveToId = () => {
    const element = document.getElementById("journals-responsible-table");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="scroll-to-top-button-wrapper">
      <Button
        className="scroll-to-top-button"
        onClick={moveToId}
        icon={<ToTopIcon />}
      >
        {children}
      </Button>
    </div>
  );
};
